export function getRequiredBaseUrl(value: string | undefined, backendName: string): string {
  const baseUrl = value?.trim();
  if (!baseUrl) throw new Error(`Missing base URL for ${backendName}`);
  return baseUrl.replace(/\/$/, "");
}

export default getRequiredBaseUrl;
